import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialslandingComponent } from './materialslanding/materialslanding.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { MatTableModule } from '@angular/material/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MymaterialsBannerComponent } from './mymaterials-banner/mymaterials-banner.component';
import { MymaterialsOrderdetailsComponent } from './mymaterials-orderdetails/mymaterials-orderdetails.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MymaterialsPrebookComponent } from './mymaterials-prebook/mymaterials-prebook.component';
import { CdkAutofill } from "@angular/cdk/text-field";
import { register } from 'swiper/element/bundle';


@NgModule({
  declarations: [
    MaterialslandingComponent,
    MymaterialsBannerComponent,
    MymaterialsOrderdetailsComponent,
    MymaterialsPrebookComponent
  ],
  imports: [
    CommonModule,
    MatTableModule,
    FormsModule,
    RouterModule,
    I18nModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatSortModule,
    ConfigModule.withConfig({
        cmsComponents: {
            SeqirusMaterialComponent: {
                component: MaterialslandingComponent,
            },
            SeqirusMaterialMyOrdersBannerComponent: {
                component: MymaterialsBannerComponent
            },
            SeqirusMaterialOrderDetailsComponent: {
                component: MymaterialsOrderdetailsComponent
            },
            SeqirusMaterialTeaserComponent: {
                component: MymaterialsPrebookComponent
            }
        }
    } as CmsConfig),
    CdkAutofill
],
 schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MaterialsukModule { 
    constructor() {
        register();
    }

}
